import { unsafeCSSVarV2 } from '@blocksuite/affine-shared/theme';
import { IS_MOBILE } from '@blocksuite/global/env';
import { PlusIcon } from '@blocksuite/icons/lit';
import { css, html } from 'lit';

import { dataViewI18nT } from '../../../../core/i18n.js';
import { WidgetBase } from '../../../../core/widget/widget-base.js';

const styles = css`
  .new-record {
    font-weight: 500;
  }

  .new-record svg {
    font-size: 20px;
    color: ${unsafeCSSVarV2('icon/primary')};
  }

  .new-record[aria-disabled='true'] {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export class DataViewHeaderToolsAddRow extends WidgetBase {
  static override styles = styles;

  private readonly onAddNewRecord = () => {
    if (this.readonly$.value) return;
    if (!this.dataSource.rowCanAdd()) {
      const reason = this.dataSource.rowAddDisabledReason();
      if (reason) this.dataViewLogic.root.config.notification.toast(reason);
      return;
    }
    this.dataViewLogic.addRow?.('start');
  };

  private get readonly$() {
    return this.view.readonly$;
  }

  override get dataSource() {
    return this.dataViewLogic.root.config.dataSource;
  }

  override render() {
    if (this.readonly$.value) {
      return;
    }
    const disabled = !this.dataSource.rowCanAdd();
    const reason = this.dataSource.rowAddDisabledReason();
    return html` <data-view-component-button
      class="affine-database-toolbar-item new-record"
      aria-disabled="${disabled ? 'true' : 'false'}"
      title="${disabled ? reason : ''}"
      .onClick="${this.onAddNewRecord}"
      .icon="${PlusIcon()}"
      .text="${IS_MOBILE
        ? html`<span style="font-weight: 500"
            >${dataViewI18nT('toolbar.newRecordShort')}</span
          >`
        : html`<span style="font-weight: 500"
            >${dataViewI18nT('toolbar.newRecord')}</span
          >`}"
    >
    </data-view-component-button>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'data-view-header-tools-add-row': DataViewHeaderToolsAddRow;
  }
}
